import { useCallback } from 'react';
import {
  isSubmitReceiptBatchDateError,
  isSubmitReceiptBatchNursingHomeInfoIncompleteException,
  isSubmitReceiptBatchResidentInfoIncompleteException,
  isSubmitReceiptBatchServiceProviderInfoIncompleteException,
  isSubmitReceiptBatchServiceProviderUserIncompleteException,
} from '@pflegenavi/service-provider-frontend/api';
import { useTranslation } from 'react-i18next';
import { useErrorSnackbar } from '@pflegenavi/web-components';

export const useHandleFailedPreviewGenerationError = (): {
  handleFailedPreviewGenerationError: (e: unknown) => void;
} => {
  const { t } = useTranslation();
  const { enqueueErrorSnackbar } = useErrorSnackbar();

  const handleFailedPreviewGenerationError = useCallback(
    // eslint-disable-next-line complexity
    (e: unknown) => {
      let messageTranslationId = 'receipt-batch-receipt-generation-failed';
      if (isSubmitReceiptBatchServiceProviderInfoIncompleteException(e)) {
        messageTranslationId =
          'receipt-batch-receipt-generation-failed-sp-info';
      } else if (
        isSubmitReceiptBatchServiceProviderUserIncompleteException(e)
      ) {
        messageTranslationId =
          'receipt-batch-receipt-generation-failed-sp-user';
      } else if (isSubmitReceiptBatchNursingHomeInfoIncompleteException(e)) {
        messageTranslationId =
          'receipt-batch-receipt-generation-failed-nh-info';
      } else if (isSubmitReceiptBatchResidentInfoIncompleteException(e)) {
        messageTranslationId =
          'receipt-batch-receipt-generation-failed-resident-info';
      } else if (isSubmitReceiptBatchDateError(e)) {
        messageTranslationId = 'receipt-batch-receipt-generation-failed-date';
      }

      enqueueErrorSnackbar(
        e,
        t(`sp-web-app.receipt-batch.${messageTranslationId}`)
      );
    },
    [enqueueErrorSnackbar, t]
  );
  return { handleFailedPreviewGenerationError };
};
